<template>
<div class="con">
  <div class="back">
    <span @click="$router.go(-1)"><i class="el-icon-back"></i>Back</span>
  </div>
  <div class="bdgWrp">
    <div class="columns clear">
      <div class="column">
        <h2>ID</h2>
        <h3>{{data.locationId ? data.locationId : '-'}}</h3>
        <h2>Vendor</h2>
        <h3>{{data.vendor ? data.vendor : '-'}}</h3>
        <h2>Country</h2>
        <h3>{{data.country ? data.country : '-'}}</h3>
        <h2>City</h2>
        <h3>{{data.city ? data.city : '-'}}</h3>
        <h2>Phone Number</h2>
        <h3>{{data.phoneNumber ? data.phoneNumber : '-'}}</h3>
      </div>
      <div class="column">
        <h2>Venue Name</h2>
        <h3>{{data.venueName ? data.venueName : '-'}}</h3>
        <h2>Address</h2>
        <h3>{{data.address ? data.address : '-'}}</h3>
        <h2>State</h2>
        <h3>{{data.state ? data.state : '-'}}</h3>
        <h2>Address</h2>
        <h3>{{data.address ? data.address : '-'}}</h3>
      </div>
    </div>
  </div>
  <div class="bdgWrp">
    <div class="columns clear">
      <div class="column">
        <!--<h2>Health Check</h2>
        <h3>{{data.healthCheck ? data.healthCheck : '-'}}</h3>-->
        <h2>Email</h2>
        <h3>{{data.email ? data.email : '-'}}</h3>
        <h2>Classification</h2>
        <h3>{{data.classification ? data.classification : '-'}}</h3>
        <!--<h2>OrganisationId</h2>
        <h3>{{data.organisationId ? data.organisationId : '-'}}</h3>-->
      </div>
      <div class="column">
        <!--<h2>Order Pre Process</h2>
        <h3>{{data.orderPreProcess ? data.orderPreProcess : '-'}}</h3>-->
        <h2>Postcode</h2>
        <h3>{{data.postalCode ? data.postalCode : '-'}}</h3>
        <!--<h2>Mapped LocationId</h2>
        <h3>{{data.mappedLocationId ? data.mappedLocationId : '-'}}</h3>-->
        <h2>Registration Time</h2>
        <h3>{{data.createTime ? data.createTime : '-'}}</h3>
      </div>
    </div>
  </div>
  <!--<div class="bdgWrp">
    <div class="columns clear">
      <div class="column" style="width:100%">
        <h2>Opening Hours</h2>
        <div class="edit-table edit-table-show">
          <el-table
              :data="tableData"
              border
              style="width: 100%">
            <el-table-column
              prop="week"
              label="WEEK"
              width="130"
              class-name="alignCenter">
            </el-table-column>
            <el-table-column
              label="TIME"
              width="448">
              <template slot-scope="scope">
                <span v-if="scope.row.time">{{scope.row.time}}</span>
                <span v-else>Closed</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
  <div class="bot clear" v-if="data.linkedVenueId === null">
    <button class="dark" @click="showd = true">Remove</button>
    <button class="light" @click="jump(`/createvenue/${$route.params.id}`)">Create New Venue</button>
    <button class="light" style="margin-right:50px" @click="jump(`/connect/${$route.params.id}`)">Connect Peiso Venue</button>
  </div>-->
  <div class="bot clear">
    <button class="dark" @click="showd = true">Remove</button>
    <button class="light" @click="jump(`/createvenue/${$route.params.id}`)">Create New Venue</button>
    <button class="light" style="margin-right:50px" @click="jump(`/connect/${$route.params.id}`)">Connect Peiso Venue</button>
  </div>

<el-dialog
        title="By deleting the account, you will also delete all content
 Are you sure you want to continue?"
        :visible.sync="showd"
        :modal-append-to-body="false"
        :show-close="false"
        class="delsmsDio_box"
        :close-on-click-modal="false"
        width="740px"
        center>
            <div class="foot_box">
                <el-button @click="showd=false" class="cardCanBtn">Cancel</el-button>
                <el-button @click="remove" class="cardConBtn">Delete</el-button>
            </div>
</el-dialog>
</div>
</template>

<script>
import api from '../../api/doshii'

export default {
  inject: ['reload'],
  data () {
    return {
      // 选中的时间段数据
      tableData: [],
      data: {},
      showd:false
    }
  },
  created () {
    api.doshiiDetail({
      params: this.$route.params.id,
      callback: this.callback
    })
  },
  methods: {
    jump (path) {
        this.$router.push(path)
    },
    callback(res) {
      var that = this
      if(res.data.code == 0){
        res.data.data.phoneNumber = res.data.data.phoneNumber ? that.$box.formatNumber(res.data.data.phoneNumber) : '-'
        res.data.data.createTime = res.data.data.createTime ? that.$box.timestampToTime(res.data.data.createTime) : '-'
        /*res.data.data.venueOpenList.forEach(item => {
          if (item.week === "Monday") {
            this.tableData.push({
              week: 'Mon', time: item.openTime === "Closed" ? '' : item.openTime
            })
          } else if (item.week === "Tuesday") {
            this.tableData.push({
              week: 'Tues', time: item.openTime === "Closed" ? '' : item.openTime
            })
          } else if (item.week === "Wednesday") {
            this.tableData.push({
              week: 'Wed', time: item.openTime === "Closed" ? '' : item.openTime
            })
          } else if (item.week === "Thursday") {
            this.tableData.push({
              week: 'Thu', time: item.openTime === "Closed" ? '' : item.openTime
            })
          } else if (item.week === "Friday") {
            this.tableData.push({
              week: 'Fri', time: item.openTime === "Closed" ? '' : item.openTime
            })
          } else if (item.week === "Saturday") {
            this.tableData.push({
              week: 'Sat', time: item.openTime === "Closed" ? '' : item.openTime
            })
          } else if (item.week === "Sunday") {
            this.tableData.push({
              week: 'Sun', time: item.openTime === "Closed" ? '' : item.openTime
            })
          }
        })*/
        that.data = res.data.data      
      } else{
        Utils.alert('', res.data.message, 'error')
      }
    },
    remove() {
      api.delDoshii({
        params: parseInt(this.$route.params.id),
        callback: this.delCallback
      })
    },
    delCallback (res) {
      var that = this
      if(res.data.code == 0){
        that.$router.go(-1)
      } else{
        Utils.alert('', res.data.message, 'error')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.con{
  padding-bottom: 110px;
}
.back{
  font-size: 14px;
  line-height: 16px;
  color: #fff;
  margin-bottom: 56px;
  font-family: 'SFProText-Semibold';
  background: #212429;
  width: 100%;
  z-index: 5;
  height: 20px;
  span{
    display: inline-block;
    width: 100px;
    cursor: pointer;
    i{
      margin-right: 10px;
    }
  }
}
.bdgWrp{
  width: 100%;
  margin-bottom: 30px;
  background: #2B3444;
  box-sizing: border-box;
  padding: 50px 30px 0 30px;
  .column{
    float: left;
    width: 50%;
    box-sizing: border-box;
  }
  .column:nth-child(1){
    padding-right: 15px;
  }
  h2{
    font-size: 14px;
    line-height: 16px;
    margin-bottom: 10px;
    color: #fff;
  }
  h3{
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 50px;
    color: #fff;
  }
  .edit-table-show{
    margin-bottom: 50px;
  }
}
.bot{
  width: 100%;
  min-width: 1024px;
  height:80px;
  background:rgba(43,52,68,1);
  box-shadow:0px -2px 4px 0px rgba(0,0,0,0.1);
  position: fixed;
  left: 0;
  width: 100%;
  bottom: 0;
  z-index: 5;
  box-sizing: border-box;
  padding: 20px 30px 0 160px;
  button{
    outline: none;
    width:150px;
    height:40px;
    background-color: transparent;
    cursor: pointer;
    float: left;
    display: block;
    font-size:18px;
    font-family: 'SFProText-Semibold';
  }
  .dark{
    border:2px solid rgba(255,255,255,1);
    color: #fff;
    margin-right: 30px;
  }
  .light{
    width: 280px;
    border:2px solid rgba(234,55,150,1);
    color: #EA3796;
    float: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/doshii/detail.vue